<template>
  <a-drawer
    :label-col="5"
    :visible="open"
    :wrapper-col="16"
    width="40%"
    :mask-closable="false"
    @close="onClose"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="销售姓名" prop="salesName">
        <a-input v-model="form.salesName" placeholder="请输入销售姓名" :max-length="64" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="销售手机号" prop="salesPhone">
        <a-input v-model="form.salesPhone" placeholder="请输入手机号" :max-length="20" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status">
        <a-radio-group v-model="form.status">
          <a-radio :value="1">启用</a-radio>
          <a-radio :value="0">停用</a-radio>
        </a-radio-group>
        <div class="form-hint">停用后该销售码将不再被埋点接口接受；历史日志保留</div>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" type="textarea" :rows="3" :max-length="200" placeholder="选填" allow-clear />
      </a-form-model-item>
      <a-form-model-item v-if="isEdit" label="推广短码">
        <a-tag color="blue">{{ form.salesCode || '—' }}</a-tag>
        <span class="form-hint" style="margin-left: 8px">短码由系统自动生成且不可修改</span>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button :loading="submitLoading" type="primary" @click="submitForm">
            <a-icon type="save"/>保存
          </a-button>
          <a-button @click="onClose">
            <a-icon type="close"/>取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { addPromotionSales, getPromotionSales, updatePromotionSales } from '@/api/promotion/sales'

export default {
  name: 'PromotionSalesCreateForm',
  data() {
    return {
      submitLoading: false,
      open: false,
      isEdit: false,
      formTitle: '新增销售',
      // 表单
      form: {
        id: undefined,
        salesCode: undefined,
        salesName: '',
        salesPhone: '',
        status: 1,
        remark: ''
      },
      rules: {
        salesName: [{ required: true, message: '销售姓名不能为空', trigger: 'blur' }],
        salesPhone: [
          {
            validator: (rule, value, callback) => {
              if (value && !/^1[3-9]\d{9}$/.test(value)) {
                callback(new Error('请输入正确的手机号'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  methods: {
    handleAdd() {
      this.reset()
      this.open = true
      this.isEdit = false
      this.formTitle = '新增销售'
    },
    handleUpdate(row, ids) {
      this.reset()
      this.open = true
      this.isEdit = true
      this.formTitle = '修改销售'
      const id = (row && row.id) || (ids && ids[0])
      if (!id) {
        this.$message.error('未选中任何记录')
        return
      }
      getPromotionSales({ id }).then(res => {
        const data = res.data || {}
        this.form.id = data.id
        this.form.salesCode = data.salesCode
        this.form.salesName = data.salesName
        this.form.salesPhone = data.salesPhone
        this.form.status = data.status != null ? data.status : 1
        this.form.remark = data.remark || ''
      }).catch(() => {
        this.$message.error('获取销售详情失败')
        this.onClose()
      })
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const api = this.isEdit ? updatePromotionSales : addPromotionSales
        const payload = {
          salesName: this.form.salesName,
          salesPhone: this.form.salesPhone,
          status: this.form.status,
          remark: this.form.remark
        }
        if (this.isEdit) {
          payload.id = this.form.id
        }
        api(payload).then(() => {
          this.$message.success(this.isEdit ? '修改成功' : '新增成功')
          this.open = false
          this.$emit('ok')
        }).catch(() => {
          this.submitLoading = false
        })
      })
    },
    onClose() {
      this.open = false
      this.submitLoading = false
    },
    reset() {
      this.form = {
        id: undefined,
        salesCode: undefined,
        salesName: '',
        salesPhone: '',
        status: 1,
        remark: ''
      }
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    }
  }
}
</script>

<style scoped>
.bottom-control {
  margin-top: 16px;
  display: flex;
  justify-content: flex-start;
}
.form-hint {
  margin-top: 4px;
  font-size: 12px;
  color: #bbb;
  line-height: 1.5;
}
</style>
